import * as yup from 'yup'

const DuplicateRequirementSchem = yup.object().shape({
    requirementDate: yup.date().required('Please select date'),
    isRouted: yup.string().required('Please select routed')
})

const duplicateRequirementInitialState = {
    requirementDate: null,
    isRouted: ''
}

export { DuplicateRequirementSchem, duplicateRequirementInitialState  };